import { ReactNode } from 'react';
import styled from 'styled-components';

import { GameStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Game as CoreGame } from '@sorare/core/src/components/Game';

import { TeamRow } from './TeamRow';

const Wrapper = styled.div`
  border-radius: var(--unit);
  background-color: var(--c-neutral-300);
`;

type GameTeam = {
  slug: string;
  name: string;
  svgUrl: string;
};

type Props = {
  game: {
    id: string;
    homeTeam: GameTeam;
    awayTeam: GameTeam;
    status: GameStatus;
    startDate: any;
    homeScore: number;
    awayScore: number;
  };
  StatusRow: ReactNode;
};

export const Game = ({ game, StatusRow }: Props) => {
  const { status, homeScore, awayScore, homeTeam, awayTeam } = game;

  return (
    <Wrapper>
      <CoreGame
        StatusRow={StatusRow}
        FirstTeamRow={
          <TeamRow
            score={awayScore}
            won={awayScore > homeScore}
            name={awayTeam.name}
            svgUrl={awayTeam.svgUrl}
            status={status}
          />
        }
        SecondTeamRow={
          <TeamRow
            score={homeScore}
            won={homeScore > awayScore}
            name={homeTeam.name}
            svgUrl={homeTeam.svgUrl}
            status={status}
          />
        }
      />
    </Wrapper>
  );
};
